import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface AlertState {
  open: boolean;
  variant: string;
  text: string;
  onClose: () => void;
  onClickButtonLabel?: string;
  onClickButton?: () => void;
}

interface SetAlertPayload {
  open: boolean;
  variant: string;
  text: string;
  onClickButtonLabel?: string;
  onClickButton?: () => void;
}

export const initialState: AlertState = {
  open: false,
  variant: 'default',
  text: '',
  onClickButtonLabel: undefined,
  onClickButton: undefined,
  onClose: () => {}
};

const alertSlice = createSlice({
  name: 'alert',
  initialState,
  reducers: {
    setAlert(state, action: PayloadAction<SetAlertPayload>) {
      const {
        open,
        variant,
        text,
        onClickButtonLabel,
        onClickButton
      } = action.payload;
      state.open = open;
      state.variant = variant;
      state.text = text;
      state.onClickButtonLabel = onClickButtonLabel;
      state.onClickButton = onClickButton;
    },
    closeAlert(state) {
      state.open = false;
      state.onClickButtonLabel = undefined;
      state.onClickButton = undefined;
    }
  }
});

export const {
  setAlert,
  closeAlert
} = alertSlice.actions;

export default alertSlice.reducer;
